import { type z } from 'zod';

import { OpenChallengeSchema } from '../verification-state/verification-state';

/**
 * What `POST /auth/verification/{email,phone}/send` answers: the open
 * challenge minus the attempts, which a fresh code has all of. Enough for the
 * screen to start its countdown and size its field without a second read.
 */
export const VerificationCodeIssuedSchema = OpenChallengeSchema.omit({ attemptsRemaining: true });

export type VerificationCodeIssued = z.infer<typeof VerificationCodeIssuedSchema>;
